import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { session, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (!session && !loading) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ redirectTo: location.pathname }}
      />
    );
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <p className="text-muted mb-0">Checking access…</p>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
